import React, { useState } from 'react';
import Sidebar from './Sidebar';

export default function Layout({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  
  return (
    <div className="flex min-h-screen bg-slate-950 text-slate-100 font-sans">
      <Sidebar 
        isOpen={isSidebarOpen} 
        setIsOpen={setIsSidebarOpen} 
        isCollapsed={isSidebarCollapsed}
        setIsCollapsed={setIsSidebarCollapsed}
      />
      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${isSidebarCollapsed ? 'sm:ml-20' : 'sm:ml-64'}`}>
        {/* Mobile Nav */}
        <header className="sm:hidden flex items-center p-4 border-b border-slate-800 bg-slate-950/90 backdrop-blur sticky top-0 z-40">
          <button onClick={() => setIsSidebarOpen(true)} className="text-slate-300 hover:text-white">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>
          </button>
          <span className="ml-4 font-semibold text-sm tracking-widest text-slate-100 uppercase">PENSENSE</span>
        </header>
        <main className="flex-1 min-w-0 relative">
          {children}
        </main>
      </div>
    </div>
  );
}
